// eslint-disable-next-line import/no-mutable-exports
let envVariables = {
  REACT_APP_IN_PRODUCTION: false,
  REACT_APP_API_BASE_URL: "https://dev-employer-api.dev-manifest.com",
  REACT_APP_CALENDLY_URL: "https://calendly.com/calendly-test-12/experiment1et",
  REACT_APP_EMPLOYER_SEARCH_URL: "https://employer-search.dev-manifest.com",
  REACT_APP_HEAP_ID: "92715569",
  REACT_APP_DEBUG: process.env.REACT_APP_DEBUG === "true",
  REACT_APP_LOGIN_CODES: ["300308"],
};

// Allow for playwright to use this file as well for E2E e2e (window is not defined)
let origin = "local";
try {
  origin = window.location.origin;
} catch (e) {
  // Do nothing
}

const isLocalEnvironment = () => {
  return origin.indexOf("localhost") > -1 || origin.indexOf("127.0.0.1") > -1;
};

const isDevelopmentEnvironment = () => {
  return (
    ["https://dev-employer-dashboard.dev-manifest.com"].includes(origin) ||
    origin.indexOf("localhost") > -1 ||
    origin.indexOf("127.0.0.1") > -1
  );
};

const isStagingEnvironment = () => {
  return origin.indexOf("staging") > -1;
};

const isProdEnvironment = () => {
  return ["https://employer.usemanifest.com"].includes(origin);
};

if (isStagingEnvironment()) {
  envVariables = {
    ...envVariables,
    REACT_APP_DEBUG: false,
    REACT_APP_API_BASE_URL: "https://staging-employer-api.dev-manifest.com",
    REACT_APP_EMPLOYER_SEARCH_URL: "https://employer-search-staging.dev-manifest.com",
  };
}

if (isProdEnvironment()) {
  envVariables = {
    ...envVariables,
    REACT_APP_DEBUG: false,
    REACT_APP_IN_PRODUCTION: true,
    REACT_APP_CALENDLY_URL: "https://calendly.com/manifestsupport/pre-launch-intro-meeting",
    REACT_APP_API_BASE_URL: "https://employer.manifestapi.com",
    REACT_APP_EMPLOYER_SEARCH_URL: "https://employersearch.manifestapi.com",
    REACT_APP_HEAP_ID: "1295109176",
  };
}

function getEnvironmentName() {
  if (isProdEnvironment()) {
    return "prod";
  }
  if (isStagingEnvironment()) {
    return "staging";
  }
  return "development";
}

// Expose a manifestTesting object that we can use in our E2E tests
try {
  window.manifestTesting = {
    baseUrl: envVariables.REACT_APP_API_BASE_URL,
    employerSearchUrl: envVariables.REACT_APP_EMPLOYER_SEARCH_URL,
    lastInitiatedTransferId: -1,
  };
} catch (e) {
  // Do nothing
}

export {
  getEnvironmentName,
  isLocalEnvironment,
  isDevelopmentEnvironment,
  isProdEnvironment,
  isStagingEnvironment,
  envVariables,
};
